import React, { createRef, useCallback, useEffect, useMemo } from "react";
import PositionedElementPreview from "../../../../components/PreviewPositionedElement/PositionedElementPreview";
import { usePositionedScreenContext } from "../../PositionedScreen";

const ElementNode = ({
  node,
  style,
  className,
  resizeHandle,
  handlers,
  type,
  saveConfigOfNode,
  onClickElement,
  device
}) => {
  const { elementRefs, tableId } = usePositionedScreenContext();

  if (elementRefs?.current && node?.id) {
    if (!elementRefs.current[node.id]) {
      elementRefs.current[node.id] = createRef();
    }
  }

  // memoize joined classes string
  const nodeClassNames = useMemo(() => node.classes?.join(" ") || "", [node.classes]);

  // memoize saveConfig callback
  const saveConfig = useCallback(
    (config) => {
      if (type === "editable") {
        saveConfigOfNode(config, node.id);
      }
    },
    [type, saveConfigOfNode, node.id]
  );

  // memoize onClickElement callback
  const handleClickElement = useCallback(
    (info) => {
      onClickElement(node, info);
    },
    [onClickElement, node]
  );

  useEffect(() => {
    const el = elementRefs.current[node.id]?.current;
    if (el) {
      el.setAttribute("data-type", node.type);
    }
  }, [elementRefs, node.id, node.type]);

  return (
    <div
      key={node.id}
      ref={elementRefs.current[node.id]}
      title={node.type}
      className={className}
      style={style}
      {...handlers}
    >
      {resizeHandle(node)}
      <PositionedElementPreview
        node={node}
        nodeClassNames={nodeClassNames}
        type={type}
        saveConfig={saveConfig}
        onClickElement={handleClickElement}
        device={device}
        tableId={tableId}
      />
    </div>
  );
};

export default ElementNode;
